import { render, staticRenderFns } from "./CompanyDocument.vue?vue&type=template&id=6abcadb6"
import script from "./CompanyDocument.vue?vue&type=script&lang=ts"
export * from "./CompanyDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports